// Client portal: my training-package progress (lessons done / left + expiry).
// COUNTS + expiry ONLY — never money (the trainer owns pricing). Hidden when
// the client has no active package (data.ok == false or no data yet).
import { useTranslation } from "react-i18next";
import { Card, CardHeader } from "../../components";
import { ProgressRing } from "./ProgressRing";
import { useMyPackage } from "../hooks/packages";

export function PackageCard() {
  const { t } = useTranslation("packages");
  const { data } = useMyPackage();
  if (!data?.ok) return null;
  const consumed = data.consumed ?? 0;
  const total = data.total_sessions ?? 0;
  const remaining = data.remaining ?? 0;
  return (
    <Card>
      <CardHeader title={data.name || t("title")} subtitle={t("subtitle")} />
      <div className="flex items-center gap-4">
        {/* Plan uses colour="volt" which is not a valid RingColour; using "coral"
            (the brand's primary signal colour) as the nearest prominent token. */}
        <ProgressRing
          value={consumed}
          target={total}
          label={t("title")}
          unit=""
          colour="coral"
          showValue
          ariaValueText={t("progress", { consumed, total })}
        />
        <div className="flex flex-col gap-1 text-sm">
          <span className="font-display text-lg font-bold text-body">
            {t("progress", { consumed, total })}
          </span>
          <span className="text-body-soft">
            {t("remaining", { count: remaining })}
          </span>
          {data.booked ? (
            <span className="text-body-soft">
              {t("booked", { count: data.booked })}
            </span>
          ) : null}
          {data.expires_on && (
            <span className="text-body-soft">
              {t("expiresLabel", { date: data.expires_on })}
            </span>
          )}
        </div>
      </div>
    </Card>
  );
}
